<template>
  <div class="chart-dialog">
    <el-dialog
      title="选择校外标识"
      :visible.sync="selectExternalDialogShow"
      width="50%"
      :before-close="dialogClose"
    >
      <div style="display: flex; justify-content: center; align-items: center;">
        <span>选择对比的学校：</span>
        <el-select v-model="outsideSchoolSign" placeholder="请选择">
          <el-option
            v-for="item in externalList"
            :key="item.outsideSchoolSign"
            :label="item.outsideSchoolSign"
            :value="item.outsideSchoolSign"
          >
          </el-option>
        </el-select>
      </div>
      <div style="display: flex; justify-content: center; margin-top: 50px">
        <el-button type="primary" @click="selectExternalConfirm"
          >下一步</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: ["selectExternalDialogShow", "externalList"],
  data() {
    return {
      outsideSchoolSign: "", // 对比的校外标识
    };
  },
  methods: {
    // 关闭弹出窗口
    dialogClose() {
      this.$emit("update:selectExternalDialogShow", false);
    },
    selectExternalConfirm() {
      this.$emit("selectExternalConfirm", this.outsideSchoolSign);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./selectExternalDialog.scss";
</style>